// Client-side city → coordinates lookup used by the Community Impact Map.
// Extend this table when new seed cities appear; unknown cities fall back to
// the country centroid so pins still render on the map.

export const CITY_COORDS = {
  // Seeded orgs / housing / opportunities / appeals
  "austin, united states": [30.2672, -97.7431],
  "leeds, united kingdom": [53.8008, -1.5491],
  "ho chi minh city, vietnam": [10.8231, 106.6297],
  "kigali, rwanda": [-1.9441, 30.0619],
  "mumbai, india": [19.076, 72.8777],
  "portland, united states": [45.5152, -122.6784],
  "toronto, canada": [43.6532, -79.3832],
  "nairobi, kenya": [-1.2921, 36.8219],
  "manila, philippines": [14.5995, 120.9842],
  "lima, peru": [-12.0464, -77.0428],
  "caracas, venezuela": [10.4806, -66.9036],
  "san jose, costa rica": [9.9281, -84.0907],
  "washington, united states": [38.9072, -77.0369],
  "new york, united states": [40.7128, -74.006],
  "london, united kingdom": [51.5074, -0.1278],
  "san francisco, united states": [37.7749, -122.4194],
};

export const COUNTRY_CENTROID = {
  "united states": [37.0902, -95.7129],
  "united kingdom": [55.3781, -3.436],
  vietnam: [14.0583, 108.2772],
  rwanda: [-1.9403, 29.8739],
  india: [20.5937, 78.9629],
  canada: [56.1304, -106.3468],
  kenya: [-0.0236, 37.9062],
  philippines: [12.8797, 121.774],
  peru: [-9.19, -75.0152],
  venezuela: [6.4238, -66.5897],
  "costa rica": [9.7489, -83.7534],
  brazil: [-14.235, -51.9253],
  mexico: [23.6345, -102.5528],
  spain: [40.4637, -3.7492],
  france: [46.6034, 1.8883],
  germany: [51.1657, 10.4515],
  australia: [-25.2744, 133.7751],
  "new zealand": [-40.9006, 174.886],
  "south africa": [-30.5595, 22.9375],
  japan: [36.2048, 138.2529],
  china: [35.8617, 104.1954],
  singapore: [1.3521, 103.8198],
  malaysia: [4.2105, 101.9758],
  "sri lanka": [7.8731, 80.7718],
};

export const resolveLatLng = (city, country) => {
  const k = `${(city || "").toLowerCase()}, ${(country || "").toLowerCase()}`.trim();
  if (CITY_COORDS[k]) return CITY_COORDS[k];
  const cc = (country || "").toLowerCase();
  if (COUNTRY_CENTROID[cc]) return COUNTRY_CENTROID[cc];
  return null;
};
